"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userMenuOption = exports.UserWrapper = exports.UserMenuInformation = exports.UserMenuContent = exports.LogoutWrapper = exports.ImageWrapper = exports.ImageSmallWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const UserWrapper = exports.UserWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1je83v55"
} : {
  target: "e1je83v55",
  label: "UserWrapper"
})(({
  hasFirstName,
  theme
}) => /*#__PURE__*/(0, _react.css)("position:relative;display:flex;flex-direction:row;&>button{gap:0.4em;&>svg{margin-left:0;}}", !hasFirstName && /*#__PURE__*/(0, _react.css)("&>button{gap:0;&:focus,&:focus-within{outline-offset:1px;outline:", theme?.primary, " 1px solid;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:UserWrapper;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UserWrapper;")));
const ImageSmallWrapper = exports.ImageSmallWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1je83v54"
} : {
  target: "e1je83v54",
  label: "ImageSmallWrapper"
})(({
  size = 25
}) => /*#__PURE__*/(0, _react.css)("height:", size, "px;width:", size, "px;border-radius:", size, "px;display:flex;justify-content:center;align-items:center;overflow:hidden;grid-row:1/3;&>img{height:", size, "px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:ImageSmallWrapper;")));
const ImageWrapper = exports.ImageWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1je83v53"
} : {
  target: "e1je83v53",
  label: "ImageWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1qkb1w8",
  styles: "height:30px;width:30px;border-radius:30px;display:flex;justify-content:center;align-items:center;overflow:hidden;margin-right:0.5em;grid-row:1/3;&>img{height:30px;}"
} : {
  name: "1qkb1w8",
  styles: "height:30px;width:30px;border-radius:30px;display:flex;justify-content:center;align-items:center;overflow:hidden;margin-right:0.5em;grid-row:1/3;&>img{height:30px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const UserMenuContent = exports.UserMenuContent = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1je83v52"
} : {
  target: "e1je83v52",
  label: "UserMenuContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1quyi9k",
  styles: "position:absolute;background-color:white;right:0;top:30px;box-sizing:border-box;width:300px;border:1px solid #cfd9ea;background-color:#ffffff;box-shadow:0 10px 15px 0 rgba(0, 0, 0, 0.1);border-radius:10px;overflow:hidden"
} : {
  name: "1quyi9k",
  styles: "position:absolute;background-color:white;right:0;top:30px;box-sizing:border-box;width:300px;border:1px solid #cfd9ea;background-color:#ffffff;box-shadow:0 10px 15px 0 rgba(0, 0, 0, 0.1);border-radius:10px;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const UserMenuInformation = exports.UserMenuInformation = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1je83v51"
} : {
  target: "e1je83v51",
  label: "UserMenuInformation"
})(process.env.NODE_ENV === "production" ? {
  name: "1rouqwn",
  styles: "display:grid;padding:1em;grid-template-columns:37px 1fr;align-items:center;&>svg{grid-row:1/3;}"
} : {
  name: "1rouqwn",
  styles: "display:grid;padding:1em;grid-template-columns:37px 1fr;align-items:center;&>svg{grid-row:1/3;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const LogoutWrapper = exports.LogoutWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1je83v50"
} : {
  target: "e1je83v50",
  label: "LogoutWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "13xfmsd",
  styles: "display:flex;padding:1em;button{width:100%;}"
} : {
  name: "13xfmsd",
  styles: "display:flex;padding:1em;button{width:100%;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const userMenuOption = theme => /*#__PURE__*/(0, _react.css)("width:100%;height:46px;background-color:white;border-radius:0;font-weight:500;border-top:1px solid #d7d7d7;cursor:pointer;&:hover{background:", theme.bg, ";}&:nth-of-type(1){border-top:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:userMenuOption;"));
exports.userMenuOption = userMenuOption;